import { GridColumnConfig } from '../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'Rebate Company Name',
    field: 'utilRebateCompanyName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Description',
    field: 'description',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Amount',
    field: 'amount',
    filter: 'numeric',
    searchable: true,
  },
  // {
  //   title: 'Created On',
  //   field: 'createdOn',
  //   filter: 'text',
  //   searchable: true,
  // }
];
